import util from '../util'

let controller = 'AnalisesOnboarding'
export default Object.assign({}, util.GetCrud(controller, null), {
  ObterConsulta: function (codigoOnboarding) {
    return util.Axios.Get(`${controller}`, codigoOnboarding)
  },
  BuscarArquivo: function(codigoOnboarding, tipoBureau) {
    return util.Axios.Get(`${controller}/${codigoOnboarding}/DownloadAnalise?tipoBureau=${tipoBureau}`)
  },
  RealizarAnaliseIndividual: function (dto) {
    return util.Axios.Post(`${controller}/AnaliseIndividual`, dto)
  },
  BuscarLinkImagensBiometria: function(codigoContaSolicitacao, codigoParceiro, documentoFederal) {
    return util.Axios.Get(`${controller}/LinkImagensBiometria/${codigoContaSolicitacao}?codigoParceiro=${codigoParceiro}&documentoFederal=${documentoFederal}`)
  },
  BuscarLinkImagensBiometriaCorrentista: function(documentoFederal, codigoParceiro, codigoConta) {
    return util.Axios.Get(`${controller}/LinkImagensBiometriaCorrentista/${documentoFederal}?codigoParceiro=${codigoParceiro}&codigoConta=${codigoConta}&`)
  },
  BuscarImagensSocio: function(documentoFederalSocio, documentoFederalCorrentista, codigoCorrentista, codigoParceiro) {
    return util.Axios.Get(`${controller}/ImagensBiometriaSocio/${documentoFederalSocio}?codigoParceiro=${codigoParceiro}&documentoFederalCorrentista=${documentoFederalCorrentista}&codigoCorrentista=${codigoCorrentista}`)
  }
})
